import { useEffect } from "react";
import { useAuthStore } from "../stores/auth.store";

export function useCurrentUser() {
  const { user, isLoading, error, fetchUser } = useAuthStore();

  useEffect(() => {
    if (!user && !isLoading && !error) {
      fetchUser();
    }
  }, [user, isLoading, error, fetchUser]);

  return { user, isLoading, error };
}
